module.exports = __webpack_public_path__ + "9c2e7292b4fcc6d60de8a4e60e7362cc.jpg";